import createAction from 'modules/spaceLook/actions/_createAction';

export const RESET_SHOULD_UPLOAD = createAction('RESET_SHOULD_UPLOAD');
